import { AdornisRouter } from '@adornis/base/client/a-router';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { BehaviorController } from '@adornis/chemistry/controllers/behavior-controller';
import { DataLoadingController } from '@adornis/chemistry/controllers/data-loading-controller';
import { Loader } from '@adornis/chemistry/controllers/loader';
import { ObservableController } from '@adornis/chemistry/controllers/observable-controller';
import '@adornis/chemistry/elements/components/x-button';
import '@adornis/chemistry/elements/components/x-flex';
import '@adornis/chemistry/elements/components/x-grid';
import '@adornis/chemistry/elements/components/x-tabs';
import { elevation } from '@adornis/chemistry/elements/theming/design';
import { ElementsDialog } from '@adornis/dialog/x-dialog';
import '@adornis/fonts/fonts';
import '@material/mwc-checkbox';
import { EventLog } from 'db/EventLog';
import { GoalAgg } from 'db/GoalAgg';
import { html } from 'lit';
import { state } from 'lit/decorators.js';
import { customElement } from 'lit/decorators/custom-element.js';
import { DateTime } from 'luxon';
import { combineLatestWith, filter } from 'rxjs';
import './components/goal-hist';
import './components/main-dashboard';
import './components/table-view';

export function shorten(string: string | undefined, length?: number) {
  if (!string) return 'SHORTERR';
  if (!length) return string?.slice(0, 20) + (string?.length > 19 ? '..' : '');
  return string?.slice(0, length) + (string?.length > length - 1 ? '..' : '');
}
export function cap(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export let courseSelected = AdornisRouter.get().queryParams.get('course');

@customElement('main-element')
export class MainElement extends ChemistryLitElement {
  styles = () => ({
    ':host': {},
  });

  public loader = new Loader(this);

  @state() private page = new ObservableController(this, AdornisRouter.get('page'));
  public routemap = { '': 0, 'goal-view': 1, 'task-view': 2, 'goal-hist': 3 };
  @state() public selectedTab = new BehaviorController(this, 0);
  public asdf = this.page.observable.subscribe(x => this.selectedTab.next(this.routemap[x || 0]));

  public qerqwer = AdornisRouter.get('page')
    .asObservable()
    .pipe(filter(Boolean), combineLatestWith(AdornisRouter.get().queryParams.pipe(filter(Boolean))))
    .subscribe(([page, query]) => {
      !page ? console.log('kein Page vorhandenkein Page vorhandenkein Page vorhanden') : '';
      //console.log('query', query);
      console.log('page ...', page);
      console.log('');
      new EventLog({ time: DateTime.now(), event: 'route', info: page + '?' + query.toString() }).create();
    });

  render() {
    console.log('router................');

    return html`<x-flex style="height:100%; overflow: auto;">
      <!-- Navigation -->
      <x-text>${this.selectedTab.value}</x-text>
      <x-flex
        style="border: black 0px solid; box-shadow:${elevation[2]}; background-color: white; position: absolute; z-index:999; width:100%;"
      >
        <x-tabs .selected=${this.selectedTab.value}>
          <x-tab
            style="padding:15px;"
            mode="text"
            icon="dashboard"
            @click="${() => {
              this.selectedTab.next(0);
              AdornisRouter.goTo('/');
              new EventLog({
                time: DateTime.now(),
                event: 'route',
                info: AdornisRouter.get('page').value + '?' + AdornisRouter.get().queryParams.getValue(),
              }).create();
            }}"
            >Dashboard
          </x-tab>
          <x-tab
            style="padding:15px;"
            mode="text"
            icon="flag"
            @click="${() => {
              this.selectedTab.next(1);
              AdornisRouter.goTo('/goal-view');
            }}"
            >Lernziele
          </x-tab>
          <x-tab
            style="padding:15px;"
            mode="text"
            icon="task"
            @click="${() => {
              this.selectedTab.next(2);
              AdornisRouter.goTo('/task-view');
            }}"
            >Aufgaben
          </x-tab>
          <x-tab
            style="padding:15px;"
            mode="text"
            icon="bar_chart"
            @click="${() => {
              this.selectedTab.next(3);
              AdornisRouter.goTo('/goal-hist');
            }}"
            >Histogram (Lernziele)
          </x-tab>
        </x-tabs>
      </x-flex>
      <!-- Main content -->
      <x-flex flex center crossaxis-center style="padding: 20px 80px;"> ${this.routing()} </x-flex>
      <!-- Footer -->
      <x-flex style="background-color:#2f2f2f; height:50px; " center crossaxis-center horizontal padding="lg">
        <x-text
          style="color:white; cursor: pointer;"
          @click="${() => ElementsDialog.success('Made with ❤ in Frankfurt')}"
        >
          AFLEK – Analyse und Förderung von Lernverläufen zur Entwicklung von Kompetenzen
        </x-text>
      </x-flex>
    </x-flex>`;
  }

  public connectedCallback(): void {
    super.connectedCallback();
    document.addEventListener(
      'visibilitychange',
      () =>
        new EventLog({
          time: DateTime.now(),
          event: 'visibility',
          info: document.visibilityState,
        }).create(),
      false,
    );
    window.addEventListener('load', () =>
      new EventLog({
        time: DateTime.now(),
        event: 'pageload',
        info: AdornisRouter.get('page').value + '?' + AdornisRouter.get().queryParams.getValue(),
      }).create(),
    );
  }

  private routing() {
    switch (this.page.value) {
      case '':
        return html`<main-dashboard></main-dashboard>`;
      case 'goal-view':
        return html`<goal-table></goal-table>`;
      case 'task-view':
        return html`<task-table></task-table>`;
      case 'goal-hist':
        return html`<goal-hist></goal-hist>`;
      case 'test':
        return html`<test-test></test-test>`;
      default:
        return html`404`;
    }
  }
}

@customElement('test-test')
class Test extends ChemistryLitElement {
  public rawGoals = new DataLoadingController(this, () => GoalAgg.subscribeAll<GoalAgg>()(GoalAgg.allFields));
  public asdf = this.rawGoals.observable.subscribe(x => console.log('rawGoals', x));

  public render() {
    return html`<x-flex space="md" crossaxis-center>
      <x-text> ${this.rawGoals.value?.length} </x-text>
      <x-text> ${this.rawGoals.value?.map(x => JSON.stringify(x.toJSON()))}</x-text></x-flex
    >`;
  }
}
